export const checkboxHandler = (
  checkboxes: number[] | undefined,
  methodId: number
) => {
  if (!checkboxes) return [];
  if (checkboxes.some((id) => id === methodId)) {
    const index = checkboxes.indexOf(methodId);
    checkboxes.splice(index, 1);
  } else checkboxes.push(methodId);
  return checkboxes;
};

export const supplierAutoCompleteTitleWidthHandler = (value: string) => {
  const length = value.length;
  if (length <= 3) return length + 1;
  if (length > 10) return length - 2;
  if (length > 14) return length - 1;
  return length;
};

export const checkedFilterCounter = (filter: any, ignoreKeyCase?: string[]) => {
  let counter = 0;
  Object.keys(filter).forEach((key: string) => {
    const value = filter[key];

    if (!ignoreKeyCase?.includes(key)) {
      if (typeof value === 'string' && value.length > 0) counter++;
      else if (
        typeof value === 'object' &&
        Array.isArray(value) &&
        value.length > 0
      )
        counter++;
      else if (
        typeof value === 'boolean' &&
        value !== null &&
        value !== undefined
      )
        counter++;
      if (typeof value === 'number' && value !== -1) counter++;
    }
  });
  return counter;
};

export const sanitizeCsvString = (...strings: string[]) => {
  return strings.map((str) => str.replace(/,/g, '')).join(',');
};
